
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comingSoon",
      function () {
        return require("private-next-pages/comingSoon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comingSoon"])
      });
    }
  